export enum ConfirmModalType {
  DEFAULT = '',
  ALERT = 'alert',
}
